import axios from "axios";
import { formatFileSize } from "./utils/helper";
import { getWorkWiseAuthToken } from "./utils/auth";
import { updateIsSaving } from "./app/EditorSlice";

// export const serverUrl = "http://localhost:3100/padApi/v2";
export const workwiseUrl = "https://workw.com/workwapi/api";
// export const workwiseUrl = "https://58.65.211.234:4436/konnectapi/api";  
export const serverUrl = "https://pad.workw.com/padApi/v2";
// export const serverUrl = "http://192.168.18.98:3100/padApi/v2";
const adminBaseURL = "https://pad.workw.com/padApi/v1";

const getWorkwiseHeaders = () => ({ 'Authorization': `Bearer ${getWorkWiseAuthToken()}` }); // workwise auth header with bearer token
let debounceTimeout;

export const padServices = {

  async saveToDatabase(milepadID, milepadData = null, summary = null, dispatch) {
    try {
      const res = await axios.post(`${serverUrl}/update`, {
        milepadID,
        milepadData,
        summary
      });
      workwiseServices.saveDocumentlastUpdate(milepadID, dispatch, res.data);
      return res;
    } catch (e) {

    }
  },

  async updateTemplate(params) {
    const { templateId, data, dispatch } = params;
    try {
      const dataWithDocType = { ...data, docType: 'milepad' };
      const res = await axios.patch(`${serverUrl}/template/update/${templateId}`, dataWithDocType);
      // Assuming similar update logic, but adjust if needed
      workwiseServices.saveDocumentlastUpdate(templateId, dispatch, res.data);
      return res;
    } catch (e) {
      console.error('Error updating template:', e);
    }
  },

  async createTemplate(data) {
    try {
      const res = await axios.post(`${serverUrl}/template/create`, data);
      return res;
    } catch (e) {
      console.error('Error creating template:', e);
      throw e;
    }
  },

  async fetchById(presentationId) {
    return axios.get(`${serverUrl}/getById/${presentationId}`);
  },

  async fetchTemplateById(templateId) {
    return axios.get(`${serverUrl}/template/getById/${templateId}`);
  },
  async getAllTemplates(params = {}) {
    try {
      // Optionally pass query params (e.g., pagination or filters) via params
      const defaultParams = { docType: 'milepad', ...params };
      const res = await axios.get(`${serverUrl}/template/getAllTemplates`, { params: defaultParams });
      return res;
    } catch (e) {
      console.error('Error fetching templates:', e);
      throw e;
    }
  },
  deleteTemplate: async (templateId) => {
    return axios.delete(`${templateBaseURL}/api/template/delete/${templateId}`);
  },
  async addSignature(signatureData, dispatch) {
    try {
      const response = await axios.post(`${serverUrl}/signature`, {
        userId: signatureData.id,
        documentId: signatureData.documentId,
        userName: signatureData.name,
        userDesignation: signatureData.designation,
        pageIndex: signatureData.pageIndex,
        signatureBoxStyle: signatureData.style
      },
        { headers: { 'workwiseAuthorization': `Bearer ${getWorkWiseAuthToken()}` } }
      );
      workwiseServices.saveDocumentlastUpdate(signatureData.documentId, dispatch, response.data);
      return response.data;
    } catch (error) {
      console.error('okkkError adding signature:', error);
      throw error;
    }
  },
  async updateSignature(signatureData, dispatch) {
    try {
      const response = await axios.patch(
        `${serverUrl}/signature/style/${signatureData.signatureId}`,
        {
          documentId: signatureData.documentId,
          signatureBoxStyle: signatureData.signatureBoxStyle
        }
        // { headers: workwiseHeaders }
      );
      workwiseServices.saveDocumentlastUpdate(signatureData.documentId, dispatch, response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating signature:', error);
      throw error;
    }
  },
  async signDocument(signatureData) {
    const { signatureId, documentId } = signatureData;

    try {
      const response = await axios.patch(
        `${serverUrl}/signature/signDocument/${signatureId}`,
        { documentId },
        {
          headers: {
            workwiseAuthorization: `Bearer ${getWorkWiseAuthToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      console.error('Error signing document:', error);
      throw error;
    }
  },
  async createVersion(documentId, data) {
    try {
      const res = await axios.post(`${serverUrl}/version/create/${documentId}`, data);
      return res;
    } catch (e) {
      console.error(e);
    }
  },
  async getAllVersions(documentId) {
    try {
      const res = await axios.get(`${serverUrl}/version/getall/${documentId}`);
      return res.data;
    } catch (e) {
      console.error(e);
    }
  },
  verifyExternal: async (id) => {
    const response = await axios.get(`${serverUrl}/external/verify/${id}`);
    return response.data;
  },
  updateDocumentPrivacy: async (data) => {
    const response = await axios.post(`${serverUrl}/external/privacyUpdate`, data);
    return response.data;
  },
};


export const workwiseServices = {

  async getDocumentById(id) {
    // Todo : To be Used When Live is Down

    // const dummyResponse = {
    //   status: 200,
    //   data: {
    //     data: {
    //       rightType: 2,
    //       members: [],
    //       name: "Dummy",
    //       creator: {
    //         id: "dss",
    //         name: "YUP",
    //         image: "tt"
    //       },
    //       createBy: "dsds"
    //     }
    //   }
    // }
    // return dummyResponse;
    return axios.get(
      `${workwiseUrl}/Authorize/Authorize?id=${id}`,
      // {},
      { headers: getWorkwiseHeaders() });
  },
  async getAllSuggestion(payload) {
    return axios.post(
      `${workwiseUrl}/Suggestion/GetAllSuggestion`,
      payload,
      { headers: getWorkwiseHeaders() });
  },
  async getAllDocumentList(payload) {
    return axios.post(
      `${workwiseUrl}/Document/GetAllDocumentList`,
      payload,
      { headers: getWorkwiseHeaders() });
  },
  async getAllSignatureDocumentList(payload) {
    return axios.post(
      `${workwiseUrl}/SignatureDocument/GetAllSignatureDocumentList`,
      payload,
      { headers: getWorkwiseHeaders() });
  },
  async addDocument(formData) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocument`,
      formData,
      { headers: getWorkwiseHeaders() });
  },
  async addDocumentMember(id, payload) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocumentMember?id=${id}`,
      payload,
      { headers: getWorkwiseHeaders() });
  },
  async addDocumentDirectory(payload) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocumentDirectory`,
      payload,
      { headers: getWorkwiseHeaders() });
  },
  async shareDocumentToAnyone(payload) {
    return axios.post(`${workwiseUrl}/Document/UpdateDocument`,
      payload,
      { headers: getWorkwiseHeaders() }
    )
  },
  async updateDocumentName(payload) {
    return axios.post(`${workwiseUrl}/Document/UpdateDocument`, payload, { headers: getWorkwiseHeaders() });
  },
  async saveDocumentlastUpdate(id, dispatch, data) {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();
    const size = new TextEncoder().encode(JSON.stringify(data)).length || 0;
    const sizeWithUnit = formatFileSize(size);

    dispatch && dispatch(updateIsSaving({ isSaving: 'Saved', lastSavedDateTime: formattedDate, fileSize: sizeWithUnit }));

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    debounceTimeout = setTimeout(async () => {
      try {
        await axios.post(`${workwiseUrl}/Document/SaveDocumentAttachment?attachmentId=${id}&fileSize=${size}`,
          {}, { headers: getWorkwiseHeaders() }
        );
        // Handle the response if needed
      } catch (e) {
        console.error("Error saving document attachment:", e);
      }
    }, 5000);
  },
  async completeDocument(id) {
    try {
      const formData = new FormData();
      formData.append('id', id);

      await axios.post(`${workwiseUrl}/Document/CompleteDocument?id=${id}`,
        formData,
        { headers: getWorkwiseHeaders() }
      );
      // Handle the response if needed
    } catch (e) {
      console.error("error", e);
    }
  },
  async removeDocumentMember(data) {
    await axios.post(
      `${workwiseUrl}/Document/RemoveDocumentMember?id=${data.documentId}&status=${data.status}`,
      data.documentMembers,
      { headers: getWorkwiseHeaders() }
    );
  },

  async saveSignature(args) {
    try {
      const response = await axios.post(
        `${workwiseUrl}/Signature/SaveSignature`,
        args,
        { headers: getWorkwiseHeaders() }
      );
      return response;
    }
    catch (error) {
      throw error;
    }
  },
  async getUserBalance() {
    return axios.get(`${workwiseUrl}/User/GetUserBalance`, {
      headers: { 'Authorization': `Bearer ${getWorkWiseAuthToken()}` }
    });
  },
};

export const adminService = {
  async getAllAdmins(params = {}) {
    try {
      const res = await axios.get(`${adminBaseURL}/getAll`, { params });
      return res;
    } catch (e) {
      console.error('Error fetching admin templates:', e);
      throw e;
    }
  },
};